import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../utils/PermissionContext';

const PermissionBasedRoute = ({ element: Element, permission, requiredRole, theme, ...rest }) => {
  const { hasPermission, loading, isAuthenticated, userRole } = usePermissions();

  if (loading) {
    return null; // Or a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to={userRole === 'customer' ? '/customer-dashboard' : '/dashboard'} replace />;
  }
  
  if (permission && !hasPermission(permission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Element theme={theme} {...rest} />;
};

export default PermissionBasedRoute;